import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell, Target, Flame, TrendingUp, Gift, Sparkles } from "lucide-react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LangContext";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const icons = { daily_mission: Target, quest_progress: Flame, readiness: TrendingUp, monthly_wrapped: Gift, product_updates: Sparkles };

export function NotificationBell() {
  const [d, setD] = useState({ items: [], unread: 0 });
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { t } = useLang();

  const load = () => api.get("/notifications").then(({ data }) => setD(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const onOpen = async (o) => {
    setOpen(o);
    if (o && d.unread > 0) { await api.post("/notifications/read-all").catch(() => {}); setTimeout(load, 300); }
  };

  return (
    <Popover open={open} onOpenChange={onOpen}>
      <PopoverTrigger asChild>
        <button data-testid="notification-bell" aria-label="Notifications"
          className="relative flex h-9 w-9 items-center justify-center rounded-full border border-border bg-card text-muted-foreground transition-colors hover:text-foreground">
          <Bell className="h-4 w-4" />
          {d.unread > 0 && <span data-testid="notification-unread" className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-rose-500 px-1 text-[10px] font-bold text-white">{d.unread}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 rounded-2xl p-2" data-testid="notification-panel">
        <div className="px-2 py-1.5 text-xs font-bold uppercase tracking-widest text-muted-foreground">{t("notifications")}</div>
        {d.items.length === 0 ? (
          <p className="px-2 py-4 text-sm text-muted-foreground" data-testid="notifications-empty">{t("notificationsEmpty")}</p>
        ) : (
          <ul className="max-h-80 space-y-1 overflow-y-auto">
            {d.items.map((n) => {
              const Icon = icons[n.type] || Bell;
              return (
                <li key={n.id}>
                  <button onClick={() => { setOpen(false); navigate(n.link || "/app/home"); }} data-testid={`notification-${n.id}`}
                    className={`flex w-full gap-3 rounded-xl p-2.5 text-left transition-colors hover:bg-secondary ${n.read ? "" : "bg-indigo-50/60"}`}>
                    <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-indigo-600/10 text-indigo-600"><Icon className="h-4 w-4" /></span>
                    <span className="min-w-0"><span className="block text-sm font-bold leading-snug">{n.title}</span><span className="block text-xs text-muted-foreground">{n.body}</span></span>
                  </button>
                </li>
              );
            })}
          </ul>
        )}
        <button onClick={() => { setOpen(false); navigate("/app/profile#notifications"); }} data-testid="notification-prefs-link" className="mt-1 w-full rounded-xl px-2 py-2 text-left text-xs font-bold text-indigo-600 hover:bg-secondary">{t("notificationPrefs")}</button>
      </PopoverContent>
    </Popover>
  );
}
